import type { KeyboardEvent } from "react";

/** Follow the visible enabled radio order; select through the existing click handler. */
export function radioKeys(event: KeyboardEvent<HTMLButtonElement>): void {
  const keys = ["ArrowLeft", "ArrowUp", "ArrowRight", "ArrowDown", "Home", "End"];
  if (!keys.includes(event.key)) return;
  const group = event.currentTarget.closest('[role="radiogroup"]');
  if (!group) return;
  const options = Array.from(group.querySelectorAll<HTMLButtonElement>('[role="radio"]'))
    .filter((option) => !option.disabled);
  const index = options.indexOf(event.currentTarget);
  if (index < 0 || !options.length) return;
  event.preventDefault();
  const next = event.key === "Home" ? 0 : event.key === "End" ? options.length - 1
    : (index + (["ArrowLeft", "ArrowUp"].includes(event.key) ? -1 : 1) + options.length) % options.length;
  options[next]?.focus();
  options[next]?.click();
}
